export default __webpack_public_path__ + "static/media/ALCRYP.b726d65a.png";